import styled from '@emotion/styled';
import { Box, Button, IconButton, Paper, Popper } from '@material-ui/core';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';

export const RangeDatepickerInputContainer = styled.div`
  display: flex;
  margin: 6px 0 4px 0;
`;

export const RangeDatepickerInput = styled.div`
  position: relative;
  flex-grow: 1;
  height: 17px;
  padding: 6.5px 14px;
  border: 1px solid rgba(0, 0, 0, 0.23);
  font-size: 13px;
  line-height: 15px;
  & > span {
    color: #00a4e4;
    margin: 0 6px;
  }
`;

export const RangeDatepickerFieldContainer = styled(Box)`
  width: 100%;
`;

export const ClearDateButton = styled(IconButton)`
  position: absolute;
  top: 2px;
  right: 0;
  margin-right: 2px;
`;

export const RangeDatePickerButton = styled(Button)`
  position: relative;
  height: 32px;
  width: 48px;
  min-width: 48px !important;
  border: 1px solid rgba(0, 0, 0, 0.23) !important;
  border-left: 0 !important;
  & svg {
    color: #555 !important;
  }
`;

export const RangeDatepickerPopper = styled(Popper)`
  z-index: 1200;
`;

export const RangeDatepickerPopperContainer = styled(Paper)`
  position: relative;
  margin: 0 0 8px 16px;
  padding: 20px 24px;
  border-radius: 8px;
`;

export const ColumnDivider = styled.div`
  width: 1px;
  background-color: rgba(0, 0, 0, 0.23);
  margin: 8px 22px;
`;

export const DateButton = styled(Button)`
  background-color: #f2f2f2 !important;
  font-weight: bold;
  font-size: 14px;
  padding: 4px 20px !important;
`;

export const Arrow = styled(ArrowDropDownIcon)`
  position: absolute;
  z-index: 1201;
  top: -28px;
  color: #fff;
  font-size: 40px !important;
  filter: drop-shadow(1px 4px 2px #536171);
`;

export const DayWrapper = styled.div<{
  isHighlighted?: boolean;
  isFirstHighlighted?: boolean;
  isLastHighlighted?: boolean;
  isSelected?: boolean;
  isBold?: boolean;
}>`
  margin: 3px 0;
  background-color: ${({ isHighlighted }) => (isHighlighted ? '#d2e9f7' : 'unset')};
  border-top-left-radius: ${({ isFirstHighlighted }) => (isFirstHighlighted ? '50%' : 0)};
  border-bottom-left-radius: ${({ isFirstHighlighted }) => (isFirstHighlighted ? '50%' : 0)};
  border-top-right-radius: ${({ isLastHighlighted }) => (isLastHighlighted ? '50%' : 0)};
  border-bottom-right-radius: ${({ isLastHighlighted }) => (isLastHighlighted ? '50%' : 0)};

  > button {
    background-color: ${({ isSelected }) => (isSelected ? '#00a4e4 !important' : 'inherit')};
    color: ${({ isSelected, isHighlighted }) =>
      isSelected ? '#fff !important' : isHighlighted ? '#63a2e4 !important' : 'inherit'};

    > span > p {
      font-weight: ${({ isBold }) => (isBold ? 'bold' : 'normal')};
    }
  }

  .MuiPickersDay-dayDisabled {
    color: rgba(0, 0, 0, 0.38);
  }
`;
